import * as Mui from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import useOperationTranslation from "../../../../hooks/useOperationTranslation";

interface Props {
    open: boolean;
    onClose: () => void;
    taskName : string;
    onOpenTask: () => void;
};
const OpenTaskConfirmation = (props: Props) => {
    const t = useOperationTranslation();

    return(
        <Mui.Dialog
            open={props.open} 
            onClose={props.onClose} 
            fullWidth
            maxWidth="sm" 
        >
            <Mui.DialogTitle>
                <Mui.Grid container spacing={1}>
                    <Mui.Grid item>
                        <InfoIcon color="inherit"/>
                    </Mui.Grid>
                    <Mui.Grid item>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.dialogs.openTaskConfirmation.title")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item marginLeft={"auto"} >
                        <Mui.IconButton onClick={props.onClose} style={{padding: "0px"}} >
                            <CloseIcon />
                        </Mui.IconButton>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>
            <Mui.DialogContent>
                <Mui.Typography>
                {t("damageForm.details.dialogs.openTaskConfirmation.body1").replace("#textElement", props.taskName)}
                </Mui.Typography>
                <Mui.Typography pt="10px">
                {t("damageForm.details.dialogs.openTaskConfirmation.body2")}
                </Mui.Typography>
            </Mui.DialogContent>
            
            <Mui.DialogActions>
                <Mui.Button  variant="outlined" size="smallPlus" onClick={props.onClose}>
                    <Mui.Typography color={'accent'} variant="h6">
                        {t("damageForm.details.dialogs.openTaskConfirmation.btnCancel")}
                    </Mui.Typography>
                </Mui.Button>

                <Mui.Button size="smallPlus" onClick={props.onOpenTask}>
                    <Mui.Typography color={'accent'} variant="h6">
                        {t("damageForm.details.dialogs.openTaskConfirmation.btnOpenTask")}
                    </Mui.Typography>
                </Mui.Button>
            </Mui.DialogActions>
        </Mui.Dialog>
    )
}
export default OpenTaskConfirmation;